import { ActionAccordionProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import { IconAccordion } from "~components/accordion"
import styled from '~/ui/styled'

const Main = styled.View`
  flex: 1;
  margin-left: ${({ theme }) => theme.space.lg};
`
const Title = styled.Text`
  font-size: ${({ theme }) => theme.fontSizes.md};
`
const SubTitle = styled.Text`
  color: ${({ theme }) => theme.colors.infoText};
  font-size: ${({ theme }) => theme.fontSizes.xs};
`
const Line = styled.View`
  margin-top: 4px;
  height: 1px;
  background-color: #e3e6ec;
`

const ActionAccordion: React.FC<ActionAccordionProps> = ({
  iconAccordionProps,
  title,
  subTitle,
  line = true,
}) => {
  const theme = useTheme()
  return (
    <IconAccordion
      {...iconAccordionProps}
      iconProps={{ size: 30, color: theme.colors.primary, ...iconAccordionProps?.iconProps }}
    >
      <Main>
        {!!title && <Title>{title}</Title>}
        {!!subTitle && <SubTitle>{subTitle}</SubTitle>}
        {!!line && <Line />}
      </Main>
    </IconAccordion>
  )
}

export default ActionAccordion
